// import React, { useState, useEffect } from "react";
// import ProjectCard from "./ProjectCard";
// import AddProject from "./AddProject";
// import styles from "./ProjectCollection.module.css";
// import { AiOutlinePlus } from "react-icons/ai";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchProjectData,
// } from "../../../../redux/slices/projectSlice.js";

// function ProjectCollection(props) {
//   const [isAddProject, setIsAddProject] = useState(false);

//   const dispatch = useDispatch();
//   const projectData = useSelector((state) => state.projectData.projectData);
//   const isLoading = useSelector((state) => state.projectData.isLoading);
//   const userPermission = useSelector(state => state.organization.userPermission);
//   const token = localStorage.getItem("token");
//   const orgEmail = localStorage.getItem("organizationEmail");

//   useEffect(() => {
//     try {
//       if (token) {
//         dispatch(fetchProjectData({ token: token, orgEmail: orgEmail }));
//       }
//     } catch (error) {
//       console.log(error);
//     }

//   }, []);


//   return (
//     <div className={styles.projectContainer}>
//       <div id="projects" className={isLoading ? "" : `${styles.projects}`}>
//         <>
//           {isLoading ? (
//             <div className={styles.fetchProjects}>Loading Projects...</div>
//           ) : (
//             projectData
//               ?.filter((project) =>
//                 userPermission?.projectAccess?.some(
//                   (access) =>
//                     access?.projectId === project?.uniqueProjectId && access?.allowed
//                 )
//               )
//               .map((project, key) => (
//                 <ProjectCard
//                   uniqueProjectId={project.uniqueProjectId}
//                   key={key}
//                   projectName={project.projectName}
//                   onlineStatus={project.projectOnlineStatus}
//                   desc={project.desc}
//                   location={project.location}
//                   adminEmail={project.admin}
//                   lastModified={project.LastModified}
//                 />
//               ))
//           )}
//         </>
//       </div>
//       <button
//         className={styles.addProject}
//         onClick={() => setIsAddProject(true)}
//       >
//         <AiOutlinePlus />
//         Add Project
//       </button>
//       {isAddProject && <AddProject setIsAddProject={setIsAddProject} />}
//     </div>
//   );
// }

// export default ProjectCollection;


import React, { useState, useEffect, useMemo } from "react";
import ProjectCard from "./ProjectCard";
import AddProject from "./AddProject";
import styles from "./ProjectCollection.module.css";
import {
  AiOutlinePlus,
  AiOutlineSearch,
  AiOutlineClose,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProjectData,
} from "../../../../redux/slices/projectSlice.js";

function ProjectCollection({ setPageTitle }) {
  const [isAddProject, setIsAddProject] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();

  const projectData = useSelector(
    (state) => state.projectData.projectData
  );

  const isLoading = useSelector(
    (state) => state.projectData.isLoading
  );

  const userPermission = useSelector(
    (state) => state.organization.userPermission
  );

  const token = localStorage.getItem("token");
  const orgEmail = localStorage.getItem("organizationEmail");

  useEffect(() => {
    if (token) {
      dispatch(
        fetchProjectData({
          token,
          orgEmail,
        })
      );
    }
  }, [dispatch, token, orgEmail]);

  const filteredProjects = useMemo(() => {
    const allowedProjects =
      projectData?.filter((project) =>
        userPermission?.projectAccess?.some(
          (access) =>
            access?.projectId === project?.uniqueProjectId &&
            access?.allowed
        )
      ) || [];

    const search = searchTerm.trim().toLowerCase();

    if (!search) {
      return allowedProjects;
    }

    return allowedProjects.filter((project) => {
      return (
        project?.projectName
          ?.toLowerCase()
          .includes(search) ||
        project?.location
          ?.toLowerCase()
          .includes(search) ||
        project?.desc
          ?.toLowerCase()
          .includes(search)
      );
    });
  }, [projectData, userPermission, searchTerm]);

  return (
    <div className={styles.projectContainer}>

      {/* FULL WIDTH SEARCH BAR */}
      <div className={styles.searchBarContainer}>
        <div className={styles.searchBar}>

          <AiOutlineSearch className={styles.searchIcon} />

          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search projects..."
            className={styles.searchInput}
          />

          {searchTerm && (
            <button
              type="button"
              className={styles.clearButton}
              onClick={() => setSearchTerm("")}
            >
              <AiOutlineClose />
            </button>
          )}

        </div>
      </div>

      {/* PROJECT AREA */}
      <div
        id="projects"
        className={
          isLoading
            ? styles.loadingContainer
            : styles.projects
        }
      >
        {isLoading ? (
          <div className={styles.loading}>
            Loading Projects...
          </div>
        ) : filteredProjects.length > 0 ? (
          filteredProjects.map((project) => (
            <ProjectCard
              key={project.uniqueProjectId}
              uniqueProjectId={project.uniqueProjectId}
              projectName={project.projectName}
              onlineStatus={project.projectOnlineStatus}
              desc={project.desc}
              location={project.location}
              adminEmail={project.admin}
              lastModified={project.LastModified}
              setPageTitle={setPageTitle}
            />
          ))
        ) : (
          <div className={styles.noProjects}>
            {searchTerm
              ? "No projects found"
              : "No projects available"}
          </div>
        )}
      </div>

      {/* ADD PROJECT */}
      <button
        type="button"
        className={styles.addProject}
        onClick={() => setIsAddProject(true)}
      >
        <AiOutlinePlus />
        Add Project
      </button>

      {isAddProject && (
        <AddProject
          setIsAddProject={setIsAddProject}
        />
      )}

    </div>
  );
}

export default ProjectCollection;
